import {
	Component,
	OnInit,
	ChangeDetectionStrategy,
	AfterViewInit,
	ChangeDetectorRef,
	HostListener,
	ViewChild,
	ElementRef
} from "@angular/core";
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { GlobalService } from "../../../services/global/global.service";
import { DMVStoreService } from "../../../services/dmv/dmv-store.service";
import { RegistrationTypes } from "../../../models/dmv/registrationTypes";
import { DmvRegistrationDuplicate } from "../../../models/dmv/dmvRegistrationDuplicate";

import { RouteFrom } from "../../../models/routeFrom";
import { AppUtil } from "../../../utils/app.util";
import { Observable } from "rxjs";
import { DMVDataService } from "src/app/services/dmv/dmv-data.service";
import { DmvCostData } from "src/app/models/dmv/dmvCostData";

declare var $: any;
@Component({
	selector: "dmv-duplicate",
	templateUrl: "./duplicate.component.html",
	styleUrls: ["./duplicate.component.css"]
})
export class DuplicateComponent implements OnInit, AfterViewInit {
	public mask = [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/];
	public errorMessage: string = "";
	public manualRenewForm: FormGroup;
	public submitted: boolean = false;
	public dmvRegistrationTypes: RegistrationTypes;
	public isloading: boolean = false;
	public requiresInsurance: boolean = false;
	public registrationDuplicateNumber: number = 0;
	public lastRegistrationDuplicateNumber: number;
	public vechicleType: string;
	public tagNumber: string;
	public insuranceCompany?: string;
	public insuranceIdNo?: string;
	public insurancePolicyNo?: string;
	public certify: boolean;
	public amount: number;
	public lateFee: number;
	public expirationDate: string;
	public dmvCostData: DmvCostData;
	public infoMessage: string = "";
	constructor(
		private router: Router,
		public globalService: GlobalService,
		public dmvStoreService: DMVStoreService,
		public dmvDataService: DMVDataService,
		private formBuilder: FormBuilder,
		private cd: ChangeDetectorRef
	) {}
	/*@ViewChild("insuranceCompanyInput", { static: false })
	insuranceCompanyInput: ElementRef;
	@ViewChild("insurancePolicInput", { static: false })
	insurancePolicInput: ElementRef;*/
	@ViewChild("vechicleTypeEle", { static: false })
	vechicleTypeEle: ElementRef;
	@HostListener("document:touchend", ["$event"])
	closeDatepickerOnclick(event) {
		if (
			event.target.offsetParent !== null &&
			event.target.id !== "expirationDate"
		) {
			if (
				!(
					event.target.offsetParent.offsetParent &&
					event.target.offsetParent.offsetParent.classList.contains(
						"datepicker"
					)
				)
			) {
				if ($(".datepicker").is(":visible")) {
					$("#expirationDate").datepicker("hide");
				}
			}
		}
	}
	ngAfterViewInit() {
		setTimeout(() => {
			this.vechicleTypeEle.nativeElement.focus();
		});
	}

	public setTwoNumberDecimal(event) {
		event.target.value = parseFloat(event.target.value).toFixed(2);
	}
	public setDownIcon(event) {
		if (
			event.target &&
			event.target.offsetParent &&
			event.target.offsetParent.classList
		) {
			event.target.offsetParent.classList.remove("upArrow");
		}
	}
	public selectChangeByKey(event) {
		if (event.code === "Enter" || event.code === "Space") {
			this.selectChange(event);
		}
	}
	public selectChange(event) {
		if (
			event.target &&
			event.target.offsetParent &&
			event.target.offsetParent.classList
		) {
			if (!event.target.offsetParent.classList.contains("upArrow")) {
				event.target.offsetParent.classList.add("upArrow");
			} else {
				event.target.offsetParent.classList.remove("upArrow");
			}
		}
	}
	ngOnInit() {
		AppUtil.log("ManualRenewComponent ngOnInit() == >");
		this.registrationDuplicateNumber = this.dmvStoreService.routeFrom
			? this.dmvStoreService.routeFrom.orderNumber
			: 0;

		this.dmvStoreService.registrationTypes$.subscribe(response => {
			if (response) {
				this.isloading = false;
				if (response["status"] && response["status"] !== 200) {
					this.errorMessage = this.dmvStoreService.agencyConfig.agencyDmvConfig.systemFailureText;
					window.scrollTo(0, 0);
				} else {
					this.isloading = false;
					this.dmvRegistrationTypes = response.registrationTypes;
				}
				this.cd.markForCheck();
			}
		});

		if (!this.dmvRegistrationTypes) {
			this.isloading = true;
			this.dmvStoreService.findRegistrationTypes();
		}

		this.creatForm();
		const that = this;
		setTimeout(() => {
			$("#expirationDate")
				.datepicker({
					direction: "down",
					format: "mm/dd/yyyy"
				})
				.on("hide", function(e) {
					if (e.date) {
						const date = e.date.getDate();
						const month = e.date.getMonth() + 1;
						const year = e.date.getFullYear();

						const fullDate =
							(month < 10 ? "0" + month : month) +
							"/" +
							(date < 10 ? "0" + date : date) +
							"/" +
							year;
						that.manualRenewForm.controls.expirationDate.setValue(fullDate);
					}
				});
		});
	}
	public creatForm() {
		if (
			this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate &&
			this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate &&
			this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate[
				this.registrationDuplicateNumber
			] &&
			this.dmvStoreService.routeFrom &&
			(this.dmvStoreService.routeFrom.from === "dmv-review-cart" ||
				this.dmvStoreService.routeFrom.from === "dmv-donation" ||
				this.dmvStoreService.routeFrom.from === "shoping-cart")
		) {
			const dmvRegistrationDuplicate: DmvRegistrationDuplicate = this
				.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate[
				this.registrationDuplicateNumber
			];
			this.dmvCostData = dmvRegistrationDuplicate.dmvCostData;
			let fullDate = "";
			if (dmvRegistrationDuplicate.expirationDate) {
				const expiration = dmvRegistrationDuplicate.expirationDate.split("-");

				fullDate =
					(Number(expiration[1]) < 10
						? "0" + Number(expiration[1])
						: expiration[1]) +
					"/" +
					(Number(expiration[2]) < 10
						? "0" + Number(expiration[2])
						: expiration[2]) +
					"/" +
					expiration[0];
			}

			this.expirationDate = fullDate || "";
			this.vechicleType = dmvRegistrationDuplicate.vechicleType || "";

			this.tagNumber = dmvRegistrationDuplicate.tagNumber || "";
		} else {
			this.dmvCostData = null;
			this.expirationDate = "";
			this.vechicleType = "";
			this.tagNumber = "";
		}

		this.manualRenewForm = this.formBuilder.group({
			vechicleType: [this.vechicleType, Validators.required],
			tagNumber: [
				this.tagNumber,
				[Validators.required, Validators.pattern(/^[a-zA-Z\d\-\s]+$/)]
			],
			expirationDate: [
				this.expirationDate,
				Validators.compose([
					Validators.required,
					Validators.pattern(
						/^(0?[1-9]|1[0-2])\/(0?[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/
					),
					this.globalService.dateRangeValidator("min")
				])
			]
		});
		this.cd.markForCheck();
	}
	public moveToRegistration(event) {
		if (this.registrationDuplicateNumber === event) {
			this.dmvStoreService.routeFrom = Object.create(null);
		} else {
			this.lastRegistrationDuplicateNumber = this.registrationDuplicateNumber;
			this.registrationDuplicateNumber = event;
			this.creatForm();
			this.globalService.routerLastUrl = this.globalService.routerCurrentUrl;
		}
	}

	public get f() {
		return this.manualRenewForm.controls;
	}

	public continue() {
		this.submitted = true;
		if (this.manualRenewForm && this.manualRenewForm.invalid) {
			console.log("duplicateForm.invalid");
			this.errorMessage = "Please correct the errors shown below";
			return;
		}
		if (this.dmvCostData) {
			this.rauteChange();
		} else {
			this.submitted = false;
			this.callCostApi(true);
		}
	}
	public changeType(event) {
		this.setDownIcon(event);
		if (
			this.manualRenewForm.controls.vechicleType.value &&
			this.dmvCostData &&
			this.manualRenewForm.controls.vechicleType.value !== this.vechicleType
		) {
			this.callCostApi(false);
			this.vechicleType = this.manualRenewForm.controls.vechicleType.value;
		}
	}

	public callCostApi(isFirstTime) {
		this.infoMessage = "";
		const type = this.manualRenewForm.controls.vechicleType.value;
		this.isloading = true;
		this.errorMessage = "";
		const agencyID = this.dmvStoreService.agencyConfig.agencyDmvConfig.agencyID;
		const sessionID = this.dmvStoreService.sessionID;
		this.dmvDataService
			.getRegistrationCostResponse(agencyID, sessionID, type, 10)
			.subscribe(
				response => {
					AppUtil.log(
						"SelectPaymentMethodComponent getPaymentDevice() ==> response:",
						response
					);
					if (response.status) {
						this.isloading = false;
						if (response.status === 200) {
							this.dmvCostData = response.body.dmvCostData;
							if (!isFirstTime) {
								this.infoMessage = "The cost has been recalculated";
							}
						} else if (response.status === 202) {
							this.errorMessage =
								"Internal system error.  Please retry.  If this problem persists, please contact our support team for assistance.";
						}
						this.cd.markForCheck();
					}
				},
				error => {
					AppUtil.log(
						"SelectPaymentMethodComponent getPaymentDevice() error:",
						error
					);
					if (
						error.name === "HttpErrorResponse" ||
						error.name === "TimeoutError" ||
						(error["status"] && error["status"] !== 200)
					) {
						this.errorMessage =
							"Internal system error.  Please retry.  If this problem persists, please contact our support team for assistance.";

						this.isloading = false;
						window.scrollTo(0, 0);
						this.cd.markForCheck();
					}
				}
			);
	}

	public rauteChange() {
		const dmvRegistrationDuplicate: DmvRegistrationDuplicate = {};

		dmvRegistrationDuplicate.vechicleType = this.manualRenewForm.controls.vechicleType.value;
		dmvRegistrationDuplicate.tagNumber = this.manualRenewForm.controls.tagNumber.value.trim();

		const expirationDate = this.manualRenewForm.controls.expirationDate.value.split(
			"/"
		);

		const fullDate =
			expirationDate[2] +
			"-" +
			(Number(expirationDate[0]) < 10
				? "0" + Number(expirationDate[0])
				: expirationDate[0]) +
			"-" +
			(Number(expirationDate[1]) < 10
				? "0" + Number(expirationDate[1])
				: expirationDate[1]);

		dmvRegistrationDuplicate.expirationDate = fullDate;
		dmvRegistrationDuplicate.dmvCostData = this.dmvCostData;

		if (!this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate) {
			this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate = [];
		}

		this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate = this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate.slice();

		if (
			this.dmvStoreService.routeFrom &&
			this.dmvStoreService.routeFrom.orderNumber !== null &&
			this.dmvStoreService.routeFrom.from === "dmv-review-cart"
		) {
			this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate[
				this.registrationDuplicateNumber
			] = dmvRegistrationDuplicate;
			this.router.navigate(["dmv-review-cart"], { skipLocationChange: true });
		} else if (
			this.dmvStoreService.routeFrom &&
			this.dmvStoreService.routeFrom.from === "shoping-cart" &&
			this.globalService.routerLastUrl !== "/dmv-duplicate"
		) {
			this.router.navigate(
				[this.globalService.routerLastUrl.replace("/", "")],
				{
					skipLocationChange: true
				}
			);
			const routeFrom: RouteFrom = Object.create(null);
			this.dmvStoreService.routeFrom = routeFrom;
			this.dmvStoreService.routeFrom.from = "dmv-duplicate";
			this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate[
				this.registrationDuplicateNumber
			] = dmvRegistrationDuplicate;
			this.registrationDuplicateNumber = this.lastRegistrationDuplicateNumber;
			this.creatForm();
			//	this.dmvStoreService.routeFrom = Object.create(null);
		} else {
			const tagNumberInCart = this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate.filter(
				function(item) {
					return item.tagNumber === dmvRegistrationDuplicate.tagNumber;
				}
			);
			if (
				tagNumberInCart &&
				tagNumberInCart.length &&
				dmvRegistrationDuplicate.tagNumber === tagNumberInCart[0].tagNumber
			) {
				let index = 0;
				const that = this;
				this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate.forEach(
					function(item) {
						if (item.tagNumber === dmvRegistrationDuplicate.tagNumber) {
							that.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate[
								index
							] = dmvRegistrationDuplicate;
						}
						index++;
					}
				);
			} else {
				this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate.push(
					dmvRegistrationDuplicate
				);
			}

			AppUtil.log(
				"ManualRenewComponent continue() == > dmvRegistrationDuplicate ==",
				dmvRegistrationDuplicate
			);

			if (this.dmvStoreService.registrationsInCart.firstIteration) {
				const routeFrom: RouteFrom = Object.create(null);
				this.dmvStoreService.routeFrom = routeFrom;
				this.dmvStoreService.routeFrom.from = "dmv-duplicate";
				this.router.navigate(["dmv-donation"], { skipLocationChange: true });
			} else {
				this.router.navigate(["dmv-review-cart"], { skipLocationChange: true });
			}
		}
	}
	public goBack() {
		AppUtil.log(
			"ManualRenewComponent goBack() == >",
			this.dmvStoreService.routeFrom
		);
		if (
			this.dmvStoreService.routeFrom &&
			this.dmvStoreService.routeFrom.from === "dmv-review-cart"
		) {
			this.router.navigate([this.dmvStoreService.routeFrom.from], {
				skipLocationChange: true
			});
		} else if (
			this.dmvStoreService.routeFrom &&
			this.dmvStoreService.routeFrom.from === "shoping-cart"
		) {
			this.router.navigate(
				[this.globalService.routerLastUrl.replace("/", "")],
				{
					skipLocationChange: true
				}
			);
			this.registrationDuplicateNumber = this.lastRegistrationDuplicateNumber;
			this.creatForm();
			this.dmvStoreService.routeFrom = Object.create(null);
		} else {
			const routeFrom: RouteFrom = Object.create(null);
			this.dmvStoreService.routeFrom = routeFrom;
			this.router.navigate(["dmv-search"], { skipLocationChange: true });
		}
	}
}
